import { render, staticRenderFns } from "./SelectProductInput.vue?vue&type=template&id=37548e90"
import script from "./SelectProductInput.vue?vue&type=script&lang=js"
export * from "./SelectProductInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports